import(/* webpackMode: "eager" */ "/vercel/path0/src/app/eliminacion-datos/page.tsx");
